// extracted by mini-css-extract-plugin
module.exports = {"LoginWrapper":"styles_LoginWrapper__2VUW0"};